<div
    class="offer-strip-carousel-layout"
    [ngStyle]="getStylesFn(item?.layoutContent?.padding)"
>
    <div class="offer-strip-carousel-container">
        <swiper
            [pagination]="
                isMobileWeb && { el: customPagination, clickable: true }
            "
            [scrollbar]="
                !isMobileWeb && { el: customScrollbar, draggable: true }
            "
            [slidesPerView]="getSlidesPerView()"
            [spaceBetween]="isMobileWeb ? 12 : 16"
            [navigation]="!isMobileWeb"
        >
            <ng-template
                swiperSlide
                *ngFor="let imgObj of item?.layoutContent?.slider"
            >
                <div class="strips-wrapper" ngClass.xs="strips-wrapper__mobile">
                    <img [src]="imgObj.banner.image" />
                </div>
            </ng-template>
        </swiper>

        <div #customPagination fxHide.gt-xs class="outer-pagination"></div>
        <div
            #customScrollbar
            fxHide.xs
            class="swiper-scrollbar outer-scrollbar"
        >
        </div>
    </div>
</div>
